export default __webpack_public_path__ + "static/media/horacinis_tech_store.50ea1312.jpg";